import React, { memo } from 'react';
import type { FunctionComponent } from 'react';
import { Icon, Button } from '@web-components-proxy';

interface SearchInputClearButtonProps {
	touched: boolean;
	inputHandler: (value: string) => void;
}

export const SearchInputClearButton: FunctionComponent<SearchInputClearButtonProps> = memo(
	({ touched, inputHandler }) => {
		if (!touched) return null;

		return (
			<Button
				tabIndex={-1}
				onClick={() => inputHandler('')}
				class="search-input__clean-button"
				design="simple"
				size="small"
				isRounded={true}
			>
				<Icon iconName="cross" class="search-input__clean-icon" />
			</Button>
		);
	},
);
